import React, { useState } from "react";
import { SimpleGrid } from "@chakra-ui/react";
import { Section } from "components/section";
import { TextTitle } from "ui/text";
import { PlatformCard } from "./platform-card";
import { AidAnimation } from "./aid";
import { CdpAnimation } from "./cdp";

export function PlatformCards() {
  const [isAidActive, setIsAidActive] = useState(false);
  const [isCdpActive, setIsCdpActive] = useState(false);

  return (
    <Section>
      <TextTitle
        align="center"
        mobileAlign="center"
        size="lg"
        title="Personalization, targeting, and experimentation with data & AI"
        description="Hightouch is completely modular. You can start with AI Decisioning or any part of our Composable CDP — it’s up to you."
        maxW="800px"
        descriptionMaxW="600px"
      />

      <SimpleGrid
        justifyItems={{ base: "center", md: "stretch" }}
        columns={{ base: 1, md: 2 }}
        gap="small"
        mt={{ base: "bigger", md: "huge" }}
      >
        <PlatformCard
          eyebrow="AI Decisioning Platform"
          title="1:1 AI agents for lifecycle marketing"
          description="AI Decisioning delivers unique and optimized experiences for each customer — without manual work or rigid rule-based segmentation."
          href="/platform/ai-decisioning"
          ctaText="Learn about AI Decisioning"
          media={<AidAnimation isCardHovered={isAidActive} />}
          onMouseEnter={() => {
            setIsAidActive(true);
          }}
          onMouseLeave={() => {
            setIsAidActive(false);
          }}
        />
        <PlatformCard
          eyebrow="Composable Customer Data Platform"
          title="Finally, a CDP that actually works"
          description="A Composable CDP is built on top of your data warehouse. It’s flexible, secure, quick-to-deploy, and self-serve for marketers."
          href="/platform/composable-cdp"
          ctaText="Learn about Composable CDP"
          media={<CdpAnimation isCardHovered={isCdpActive} />}
          onMouseEnter={() => {
            setIsCdpActive(true);
          }}
          onMouseLeave={() => {
            setIsCdpActive(false);
          }}
        />
      </SimpleGrid>
    </Section>
  );
}
